export const routes = {
    ConditionMonitoring: '/conditionmonitor',
    Overview: '/conditionmonitor/overview',
    PowertrainAssetsOverview: '/conditionmonitor/powertrain-assets-overview',
    ConditionOverview: '/conditionmonitor/condition-overview',
    ConditionOverviewV2: '/conditionmonitor/condition-overviewV2',
    MaintenanceOverview: '/conditionmonitor/maintenance-overview',
    MaintenanceOverviewV2: '/conditionmonitor/maintenance-overviewV2',
    Map: '/conditionmonitor/map',
    Cbm: '/conditionmonitor/cbm',
    PowertrainAndAssetDetails: '/pt-asset-details',
    DetailedInformation: '/pt-asset-details/detailed-information',
    AssetDetails: '/pt-asset-details/detailed-information/asset-details',
    OperationalParameters: '/pt-asset-details/detailed-information/operational-parameters',
    ConditionInsights: '/pt-asset-details/detailed-information/condition-insights',
    OperationalParametersV2: '/pt-asset-details/detailed-information/operational-parameters',
    LimitConfig: '/pt-asset-details/detailed-information/asset-limit-config',
    // LimitConfigV2: '/pt-asset-details/detailed-information/asset-limit-configV2',
    EventLog: '/pt-asset-details/detailed-information/event-log',
    LimitsConfiguration: '/pt-asset-details/detailed-information/limits-configuration',
    SensorProperties: '/pt-asset-details/detailed-information/sensor-properties',
    AdvancedAnalyticsV2: '/pt-asset-details/detailed-information/advanced-analyticsv2',
    CrossKpi: '/conditionmonitor/cross-asset-analysis',
    CrossKpiV2: '/conditionmonitor/cross-asset-analysis-v2',
    ConditionBasedMaintenance: '/pt-asset-details/condition-based-maintenance',
    Tools: '/tools',
    ToolsPowertrainConfiguration: '/tools/powertrain-configuration',
    ToolsPowertrainConfigurationV2: '/tools/configuration-management',
    ToolsSubscriptionStatus: '/tools/subscription-status',
    ToolsUserManagement: '/tools/user-management',
    ToolsAssetManagement: '/tools/access-management',
    ToolsReportManagement: '/tools/report-management',
    ToolsSensorFirmwareManagement: '/tools/sensor-firmware-maintenance',
    ToolsEventLog: '/tools/event-log',
    ToolsSymptomMonitoring: '/tools/symptom-monitoring',
    User: '/user',
    UserProfile: '/user/profile',
    UserUnits: '/user/units',
    NotificationSettings: '/user/notification-settings',
    Reports: '/reports',
    FleetOverview: '/fleet-overview', /* FLEETS OVERVIEW VIEW */
    FleetDashboard: '/fleet-dashboard', /* FLEETS DASHBOARD VIEW */

    // Gateway Management Main Routes
    ToolsGatewayManagement: '/tools/gateway-management',
    GatewayManagementGateways: '/tools/gateway-management/gateways',
    GatewayManagementGatewayEvents: '/tools/gateway-management/gateway-events',

    // Gateway Management Sub-routes for Gateways section
    GatewayManagementInfo: '/tools/gateway-management/gateways/gateway-info',
    GatewayManagementConnectedAssets: '/tools/gateway-management/gateways/connected-assets',
    GatewayManagementConnectedHistory: '/tools/gateway-management/gateways/connected-history',
    GatewayManagementConnectedAssetsDrives: '/tools/gateway-management/gateways/connected-assets/drives',
    GatewayManagementConnectedAssetsEnvironmentSensors: '/tools/gateway-management/gateways/connected-assets/environment-sensors',
    GatewayManagementConnectedAssetsEnvironmentSensor: '/tools/gateway-management/gateways/connected-assets/environment-sensor',

    // Gateway Events Sub-routes
    GatewayManagementSmartSensorDCU: '/tools/gateway-management/gateway-events/smart-sensor-dcu',
    GatewayManagementSmartSensor: '/tools/gateway-management/gateway-events/smart-sensor',
    GatewayManagementAPP: '/tools/gateway-management/gateway-events/app',
    GatewayManagementDriveDCU: '/tools/gateway-management/gateway-events/drive-dcu',
};

// export const defaultLandingPage = routes.ConditionMonitoring;
export const defaultLandingPage = routes.FleetDashboard;
